import { Auth } from 'aws-amplify'

import { amplifyConfiguration } from './amplifyConfiguration'

// `cognitoAction` used by `ForgotPasswordEmailForm`
export async function forgotPasswordTriggerEmail({
  email,
}: {
  email: string
}): Promise<void> {
  if (window.Cypress) {
    const AuthMocked = await import(
      '@util/amplify-mock-implementations/mocked-cognito-api'
    )
    AuthMocked.default.forgotPasswordTriggerEmail(email)
    return
  }

  await amplifyConfiguration.configureViaEmail(email)
  await Auth.forgotPassword(email)
}
